import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CustomerAreaContainerComponent } from '../../containers/customer-area-container/customer-area-container.component';
import { SponsorshipListComponent } from './components/sponsorship-list/sponsorship-list.component';
import { TokenLocalStorageService } from '../authentication/services/token-local-storage.service';

const routes: Routes = [
  {
    path: '', component: CustomerAreaContainerComponent,
    children: [
      { path: 'parrainage',
        children: [
          { path: '', component: SponsorshipListComponent, canActivate: [TokenLocalStorageService] },
          { path: ':tab', pathMatch: 'full', component: SponsorshipListComponent, canActivate: [TokenLocalStorageService] },
        ]
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SponsorshipRoutingModule { }
